import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommArrowsSwapIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M14.4696 1.46967C14.7625 1.17678 15.2374 1.17678 15.5303 1.46967L19.8232 5.76256C19.8312 5.77064 19.8394 5.77877 19.8475 5.78692C19.9926 5.9319 20.1495 6.08867 20.2641 6.23885C20.3983 6.41478 20.5428 6.66653 20.5428 7C20.5428 7.33347 20.3983 7.58522 20.2641 7.76115C20.1495 7.91134 19.9926 8.06811 19.8475 8.21309C19.8394 8.22124 19.8312 8.22936 19.8232 8.23744L15.5303 12.5303C15.2374 12.8232 14.7625 12.8232 14.4696 12.5303C14.1767 12.2374 14.1767 11.7626 14.4696 11.4697L18.1893 7.75H4.00012C3.58591 7.75 3.25012 7.41421 3.25012 7C3.25012 6.58579 3.58591 6.25 4.00012 6.25H18.1893L14.4696 2.53033C14.1767 2.23744 14.1767 1.76256 14.4696 1.46967ZM9.53033 11.4697C9.82322 11.7626 9.82322 12.2374 9.53033 12.5303L5.81055 16.2501L20 16.2499C20.4142 16.2499 20.75 16.5857 20.75 16.9999C20.75 17.4141 20.4142 17.7499 20 17.7499L5.81077 17.7501L9.53033 21.4697C9.82322 21.7626 9.82322 22.2374 9.53033 22.5303C9.23744 22.8232 8.76256 22.8232 8.46967 22.5303L4.17678 18.2374C4.1687 18.2294 4.16057 18.2212 4.15241 18.2131C4.00732 18.0681 3.85042 17.9113 3.73584 17.7612C3.60161 17.5852 3.45711 17.3335 3.45711 17C3.45711 16.6665 3.60161 16.4148 3.73584 16.2388C3.85043 16.0887 4.00733 15.9319 4.15242 15.7869C4.16058 15.7788 4.1687 15.7706 4.17678 15.7626L8.46967 11.4697C8.76256 11.1768 9.23744 11.1768 9.53033 11.4697Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
